import * as types from '../constants/instrumentListConstants';
import config from './../config.js';
import appConstants from './../appConstants.js'

const initialState = {
  loading: false,
  loaded: false,
  check:1234,
  socketData:null,
  cmdt:"",
  cmdtArr:[],
  socketDataStatic: [],
  socketNeoData:[],
  trdPanelData:[],
  webSocketFlag:false,
  accBalBean:{
    defacccode:null,
    mrgPerc:null,
    lossLimit:null,
    nopLimit:null,
    dealValLimit:null,
    haltMrgPerc:null,
    FD:null,
    marginFreeNOP:null,
    detFundsBeanMap:null,
    detonlBeanMap:null,
    detneoBeanMap:null,
    TQFlag:false,
    UQFlag:false,
    OQFlag:false,
  },
  marginData:
  {
    totfunds:null,
    totReval:null,
    tmpReval:null,
    totMA:null,
    tempMA:null,
    appliedMrg:null,
    mrgAtPerc:null,
    finalMargin:null,
  },
  status: "1",
  socketDataRandomNo:0,
  limitOrdBookProxi:[],
  proxiRandomNo:0,
  cmdtyArr:[],
  randomNoVD:0,
  fwdSubscription: null,
  tenorData:[],
  LSData :{},
  tenorStatus: null,
  swapLocations: [],
};

const fwdSubscriptionMap = new Map();

const intializeMargindata = (accBal,instList,neoComList) => {
var temponldetBeanMap=new Map();
var tempdetFundsBeanMap=new Map();
var tempneodetBeanMap=new Map();
let ask;
let bid;
let TvFlag=false;
let UvFlag=false;
let OvFlag=false;
accBal.STKA.map((item,index) => {
    if((item.INSTID)!=="" && (item.INSTID)!==null){
      item.R=0.00;
      item.V=0;
      temponldetBeanMap.set(item.INSTID,item);
      // RD25367 in report Price and valuation should not display zero code changes
      temponldetBeanMap.get(item.INSTID).MA=calculateValue(temponldetBeanMap.get(item.INSTID),temponldetBeanMap.get(item.INSTID).MP,item.SPOT_ASK,item.SPOT_BID,accBal.FD,"Q");
      temponldetBeanMap.get(item.INSTID).R=calculateValue(temponldetBeanMap.get(item.INSTID),temponldetBeanMap.get(item.INSTID).MP,item.SPOT_ASK,item.SPOT_BID,accBal.FD,"R");
      temponldetBeanMap.get(item.INSTID).V=calculateValue(temponldetBeanMap.get(item.INSTID),100,item.SPOT_ASK,item.SPOT_BID,accBal.FD,"Q");
      // RD25367 in report Price and valuation should not display zero code changes
      temponldetBeanMap.get(item.INSTID).MA=calculateValue(temponldetBeanMap.get(item.INSTID),temponldetBeanMap.get(item.INSTID).MP,item.SPOT_ASK,item.SPOT_BID,accBal.FD,"Q");
      temponldetBeanMap.get(item.INSTID).R=calculateValue(temponldetBeanMap.get(item.INSTID),temponldetBeanMap.get(item.INSTID).MP,item.SPOT_ASK,item.SPOT_BID,accBal.FD,"R");
      temponldetBeanMap.get(item.INSTID).V=calculateValue(temponldetBeanMap.get(item.INSTID),100,item.SPOT_ASK,item.SPOT_BID,accBal.FD,"Q");
    }
    else {
      item.R=0.00;
      item.V=0;
      tempneodetBeanMap.set(item.C,item);
      // RD25367 in report Price and valuation should not display zero code changes
      tempneodetBeanMap.get(item.C).MA=calculateValue(tempneodetBeanMap.get(item.C),tempneodetBeanMap.get(item.C).MP,item.SPOT_ASK,item.SPOT_BID,accBal.FD,"Q");
      tempneodetBeanMap.get(item.C).R=calculateValue(tempneodetBeanMap.get(item.C),tempneodetBeanMap.get(item.C).MP,item.SPOT_ASK,item.SPOT_BID,accBal.FD,"R");
      tempneodetBeanMap.get(item.C).V=calculateValue(tempneodetBeanMap.get(item.C),100,item.SPOT_ASK,item.SPOT_BID,accBal.FD,"Q");
      // RD25367 in report Price and valuation should not display zero code changes
      tempneodetBeanMap.get(item.C).MA=calculateValue(tempneodetBeanMap.get(item.C),tempneodetBeanMap.get(item.C).MP,item.SPOT_ASK,item.SPOT_BID,accBal.FD,"Q");
      tempneodetBeanMap.get(item.C).R=calculateValue(tempneodetBeanMap.get(item.C),tempneodetBeanMap.get(item.C).MP,item.SPOT_ASK,item.SPOT_BID,accBal.FD,"R");
      tempneodetBeanMap.get(item.C).V=calculateValue(tempneodetBeanMap.get(item.C),100,item.SPOT_ASK,item.SPOT_BID,accBal.FD,"Q");
    }
  });
   accBal.FA.map((item,index) => {
	   item.Q=parseFloat(item.Q);
	   item.FA=parseFloat(item.V);
    tempdetFundsBeanMap.set(item.C,item);
    });
    for (var [key, value] of instList) {
          let item=value;
       if(item.I){
         if(temponldetBeanMap.get(item.I)!==undefined)
         {
           let ask=item.MA;
           let bid =item.MB;
          temponldetBeanMap.get(item.I).MA=calculateValue(temponldetBeanMap.get(item.I),temponldetBeanMap.get(item.I).MP,ask,bid,accBal.FD,"Q");
          temponldetBeanMap.get(item.I).dec=item.dec;
          temponldetBeanMap.get(item.I).R=calculateValue(temponldetBeanMap.get(item.I),temponldetBeanMap.get(item.I).MP,ask,bid,accBal.FD,"R");
          temponldetBeanMap.get(item.I).V=calculateValue(temponldetBeanMap.get(item.I),100,ask,bid,accBal.FD,"Q");
          temponldetBeanMap.get(item.I).TV=calculateValue(temponldetBeanMap.get(item.I),100,ask,bid,accBal.FD,"TQ");
          if(parseInt(temponldetBeanMap.get(item.I).TV)!==0)
          {
            TvFlag=true;
          }
          temponldetBeanMap.get(item.I).UV=calculateValue(temponldetBeanMap.get(item.I),100,ask,bid,accBal.FD,"UQ");
          if(parseInt(temponldetBeanMap.get(item.I).UV)!==0)
          {
            UvFlag=true;
          }
          temponldetBeanMap.get(item.I).OV=calculateValue(temponldetBeanMap.get(item.I),100,ask,bid,accBal.FD,"OQ");
          if(parseInt(temponldetBeanMap.get(item.I).UV)!==0)
          {
            OvFlag=true;
          }
         }
       }
     }
 neoComList.map((item,index)=>{
 if(item.stk_type){
    if(tempneodetBeanMap.get(item.stk_type)!==undefined){
      tempneodetBeanMap.get(item.stk_type).MA=calculateValue(tempneodetBeanMap.get(item.stk_type),tempneodetBeanMap.get(item.stk_type).MP,item.ask_price,item.bid_price,accBal.FD,"Q");
      tempneodetBeanMap.get(item.stk_type).R=calculateValue(tempneodetBeanMap.get(item.stk_type),tempneodetBeanMap.get(item.stk_type).MP,item.ask_price,item.bid_price,accBal.FD,"R");
      tempneodetBeanMap.get(item.stk_type).V=calculateValue(tempneodetBeanMap.get(item.stk_type),100,item.ask_price,item.bid_price,accBal.FD,"Q");
      tempneodetBeanMap.get(item.stk_type).TV=calculateValue(tempneodetBeanMap.get(item.stk_type),100,item.ask_price,item.bid_price,accBal.FD,"TQ");
      tempneodetBeanMap.get(item.stk_type).UV=calculateValue(tempneodetBeanMap.get(item.stk_type),100,item.ask_price,item.bid_price,accBal.FD,"UQ");
      tempneodetBeanMap.get(item.stk_type).dec=2;
      tempneodetBeanMap.get(item.stk_type).OV=calculateValue(tempneodetBeanMap.get(item.stk_type),100,item.ask_price,item.bid_price,accBal.FD,"OQ");
    }
 }
 });
  return{
    defacccode:accBal.AC,
    mrgPerc:accBal.MP,
    lossLimit:accBal.LL,
    nopLimit:accBal.NOPL,
    dealValLimit:accBal.DL,
    haltMrgPerc:accBal.HM,
    FD:accBal.FD,
    marginFreeNOP:accBal.MFNOP,
    detFundsBeanMap:tempdetFundsBeanMap,
    detonlBeanMap:temponldetBeanMap,
    detneoBeanMap:tempneodetBeanMap,
    TQFlag:TvFlag,
    UQFlag:UvFlag,
    OQFlag:OvFlag,
  }
};
const updateNeoMargin=(accBal,message)=>
{
  const msg=JSON.parse(message.data)
    if(accBal.detneoBeanMap.get(msg.stkType)!==undefined){
      accBal.detneoBeanMap.get(msg.stkType).MA=calculateValue(accBal.detneoBeanMap.get(msg.stkType),accBal.detneoBeanMap.get(msg.stkType).MP,msg.SA,msg.SB,accBal.FD,"Q");
      accBal.detneoBeanMap.get(msg.stkType).R=calculateValue(accBal.detneoBeanMap.get(msg.stkType),accBal.detneoBeanMap.get(msg.stkType).MP,msg.SA,msg.SB,accBal.FD,"R");
      accBal.detneoBeanMap.get(msg.stkType).V=calculateValue(accBal.detneoBeanMap.get(msg.stkType),100,msg.SA,msg.SB,accBal.FD,"Q");
      accBal.detneoBeanMap.get(msg.stkType).TV=calculateValue(accBal.detneoBeanMap.get(msg.stkType),100,msg.SA,msg.SB,accBal.FD,"TQ");
      accBal.detneoBeanMap.get(msg.stkType).UV=calculateValue(accBal.detneoBeanMap.get(msg.stkType),100,msg.SA,msg.SB,accBal.FD,"UQ");
      accBal.detneoBeanMap.get(msg.stkType).OV=calculateValue(accBal.detneoBeanMap.get(msg.stkType),100,msg.SA,msg.SB,accBal.FD,"OQ");

    }
  return{
    defacccode:accBal.defacccode,
    mrgPerc:accBal.mrgPerc,
    lossLimit:accBal.lossLimit,
    nopLimit:accBal.nopLimit,
    dealValLimit:accBal.dealValLimit,
    haltMrgPerc:accBal.haltMrgPerc,
    FD:accBal.FD,
    marginFreeNOP:accBal.marginFreeNOP,
    detFundsBeanMap:accBal.detFundsBeanMap,
    detonlBeanMap:accBal.detonlBeanMap,
    detneoBeanMap:accBal.detneoBeanMap,
    TQFlag:accBal.TQFlag,
    UQFlag:accBal.UQFlag,
    OQFlag:accBal.OQFlag,
  }
}
const updateMargin=(accBal,message)=>
{
  const msg1 = JSON.parse(message.data).data;
  for(var index=0;index<msg1.length;index++)
  {
    const msg=JSON.parse(msg1[index]);
    if((accBal.detonlBeanMap.get((msg.I)))!=undefined)
    {
      accBal.detonlBeanMap.get((msg.I)).ask=msg.MA;
      accBal.detonlBeanMap.get((msg.I)).bid=msg.MB;
      accBal.detonlBeanMap.get((msg.I)).MA=calculateValue(accBal.detonlBeanMap.get((msg.I)),accBal.detonlBeanMap.get(msg.I).MP,msg.MA,msg.MB,accBal.FD,"Q");
      accBal.detonlBeanMap.get((msg.I)).R=calculateValue(accBal.detonlBeanMap.get((msg.I)),accBal.detonlBeanMap.get(msg.I).MP,msg.MA,msg.MB,accBal.FD,"R");
      accBal.detonlBeanMap.get((msg.I)).V=calculateValue(accBal.detonlBeanMap.get((msg.I)),100,msg.MA,msg.MB,accBal.FD,"Q");
      accBal.detonlBeanMap.get((msg.I)).TV=calculateValue(accBal.detonlBeanMap.get((msg.I)),100,msg.MA,msg.MB,accBal.FD,"TQ");
      accBal.detonlBeanMap.get((msg.I)).UV=calculateValue(accBal.detonlBeanMap.get((msg.I)),100,msg.MA,msg.MB,accBal.FD,"UQ");
      accBal.detonlBeanMap.get((msg.I)).OV=calculateValue(accBal.detonlBeanMap.get((msg.I)),100,msg.MA,msg.MB,accBal.FD,"OQ");
    }
  }
  return{
    defacccode:accBal.defacccode,
    mrgPerc:accBal.mrgPerc,
    lossLimit:accBal.lossLimit,
    nopLimit:accBal.nopLimit,
    dealValLimit:accBal.dealValLimit,
    haltMrgPerc:accBal.haltMrgPerc,
    FD:accBal.FD,
    marginFreeNOP:accBal.marginFreeNOP,
    detFundsBeanMap:accBal.detFundsBeanMap,
    detonlBeanMap:accBal.detonlBeanMap,
    detneoBeanMap:accBal.detneoBeanMap,
    TQFlag:accBal.TQFlag,
    UQFlag:accBal.UQFlag,
    OQFlag:accBal.OQFlag,
  }
}
const calculateMargin=(accBal)=>
{
  if(accBal.detFundsBeanMap!==null)
  {
    var cal_totReval=0;
    var cal_tmpReval=0;
    var cal_totMA=0;
    var cal_tmpMA=0;
    var cal_totfunds=0;
   for (var [key, value] of accBal.detFundsBeanMap) {
        if(value!=null)
        {
          cal_totfunds=cal_totfunds+value.Q;
        }
      };
    for (var [key, value] of accBal.detonlBeanMap) {
      if(value!=null)
      {
        cal_totReval=cal_totReval+value.V;
        cal_tmpReval=cal_tmpReval+Math.abs(value.V);
        cal_totMA=cal_totMA+value.MA;
        cal_tmpMA=cal_tmpMA+Math.abs(value.MA);
      }
    };
    for (var [key, value] of accBal.detneoBeanMap) {
      if(value!=null)
      {
        cal_totReval=cal_totReval+value.V;
        cal_tmpReval=cal_tmpReval+Math.abs(value.V);
        cal_totMA=cal_totMA+value.MA;
        cal_tmpMA=cal_tmpMA+Math.abs(value.MA);
      }
    };
    const cal_mrgAtPerc = cal_tmpMA*-1;
    const cal_calcuArray=[cal_tmpReval, cal_totReval, cal_totfunds, cal_tmpMA, cal_totMA];
    const cal_ama=calculateAMA(cal_calcuArray,accBal.marginFreeNOP,accBal.nopLimit,accBal.mrgPerc);
    const cal_excShortVal	= 	accBal.LL + cal_ama + cal_totReval + cal_totfunds;
  	const cal_BEFactor	= 	(cal_tmpReval == 0) ? 0 : ( cal_totfunds + cal_totReval)/cal_tmpReval;
    const cal_finalMargin=((cal_BEFactor+1)*100).toFixed(2);
    return{
      totfunds:cal_totfunds,
      totReval:cal_totReval,
      tmpReval:cal_tmpReval,
      totMA:cal_totMA,
      tempMA:cal_tmpMA,
      appliedMrg:cal_ama,
      mrgAtPerc:cal_mrgAtPerc,
      finalMargin:cal_finalMargin,
    }
  }else{
    return {};
  }
}
const calculateAMA=(currTotWithOrd,marginFreeNOP,nopLimit,mrgPerc)=>
 {
		if (marginFreeNOP!==false) {
			if (parseFloat(currTotWithOrd[0]) < parseFloat(nopLimit)) {
				    return 0;
			} else {
				    return (((parseFloat(nopLimit) - parseFloat(currTotWithOrd[0]))*parseFloat(mrgPerc))/100);
			}
		} else {
			if ((currTotWithOrd[0] < nopLimit) || (nopLimit == 0)) {
				    return currTotWithOrd[3]*-1;
			} else {
				    return (((nopLimit - currTotWithOrd[0])*mrgPerc/100)+(currTotWithOrd[3]*-1));
			}

		}

	}
const calculateValue=(accDet,merginperc,askrate,bidrate,factor,flag)=>
  
{
    const merg=merginperc/100;
    var tmpQty=0;
    if(flag==="Q" || flag==="R"){
      tmpQty=accDet.UQ+accDet.Q+accDet.TQ;
    }
    if(flag==="OQ"){
      tmpQty=accDet.OQ;
    }
    if(flag==="TQ"){
      tmpQty=accDet.TQ;
    }
    if(flag==="UQ"){
       tmpQty=accDet.UQ;
    }
    const dorm=accDet.DORM;
    var rate=0;
    if(tmpQty < 0)
    {
       rate=askrate;
    }
    else {
       rate=bidrate;
    }

    if(rate===0){ // RD25367 in report Price and valuation should not display zero code changes
        if (tmpQty < 0) {
            rate = accDet.SPOT_ASK ? accDet.SPOT_ASK : 0;
        } else {
            rate = accDet.SPOT_BID ? accDet.SPOT_BID : 0;
        }
    }
    
    if(flag==="R"){
      return rate;
    }
    if (dorm.toUpperCase()==='D') {
      if (rate === 0) { // added to resolve issue.. valuation shows infinite 
        rate = 0;
    } else {
			rate = parseFloat((tmpQty/rate).toFixed(config.roundOff));
			rate= rate*merg;
    }
	 }
    else {
  			rate = tmpQty*rate;
  			rate = rate*merg;
      	}
        rate=parseFloat(rate.toFixed(config.roundOff));
        rate=(rate/factor);
        rate=parseFloat(rate.toFixed(config.roundOff));
        return rate;

}
const getInitialSocketData = (instrumentList) => {
try{
  var tempInstList=new Map();
   instrumentList.map((item,index) => {
    var dec; var minDec=0;
    if((item.TR).toString().split(".")[1]){
      dec = (item.TR).toString().split(".")[1].length
       for (let i = 0; i < dec; i++) {
        if((item.TR).toString().split(".")[1][i] === '0'){ minDec +=1 ; }
      }
    }
    else{
      dec = 0;
    }
    var BMdec;var BMminDec=0;
    if((item.BRF).toString().split(".")[1]){
      BMdec = (item.BRF).toString().split(".")[1].length
       for (let i = 0; i < BMdec; i++) {
        if((item.BRF).toString().split(".")[1][i] === '0'){ BMminDec +=1 ; }
      }
    }
    else{
      BMdec = 0;
    }
    var amntDec=0; var amntMinDec=0
    if((item.TF).toString().split(".")[1]){
      amntDec = (item.TF).toString().split(".")[1].length
      for (let i = 0; i < amntDec; i++) {
        if((item.TF).toString().split(".")[1][i] === '0'){ amntMinDec +=1 ; }
      }
    }
   var pDec=0; var pMinDec=0;
    if((item.P).toString().split(".")[1]){
      pDec = (item.P).toString().split(".")[1].length
      for (let i = 0; i < pDec; i++) {
        if((item.P).toString().split(".")[1][i] === '0'){ pMinDec +=1 ; }
      }
    }
    var mf = JSON.parse(item.PTN).mf;
    var rf = JSON.parse(item.PTN).rf;
    item.ask =item.MA.toFixed(dec);
    item.bid=item.MB.toFixed(dec);
    item.cmdty=item.ID;
    item.dec=dec;
    item.BMdec= BMdec;
    item.amntDec=amntDec;    
    item.amntMinDec=amntMinDec;
    item.pDec=pDec;    
    item.pMinDec=pMinDec;
    item.minDec=minDec;
    item.BMminDec=BMminDec;
    item.RT=new Date().valueOf();
    var diff=Math.abs(Math.round(((item.MB.toFixed(dec)-item.MA.toFixed(dec)))*mf)).toFixed(rf);
    item.diff=diff;
    tempInstList.set(item.I,item);
    localStorage.setItem(item.I, JSON.stringify(item));
    });
}catch(e){
  console.log(e);
}
  return tempInstList;
};

const getInitialStaticSocketData = (instrumentList) => {
  return instrumentList.map((item,index) => {
    var dec; var minDec=0;
    if((item.TR).toString().split(".")[1]){
      dec = (item.TR).toString().split(".")[1].length
       for (let i = 0; i < dec; i++) {
        if((item.TR).toString().split(".")[1][i] === '0'){ amntMinDec +=1 ; }
      }
    }
    else{
      dec = 0;
    }
    var BMdec;var BMminDec=0;
    if((item.BRF).toString().split(".")[1]){
      BMdec = (item.BRF).toString().split(".")[1].length
       for (let i = 0; i < BMdec; i++) {
        if((item.BRF).toString().split(".")[1][i] === '0'){ BMminDec +=1 ; }
      }
    }
    else{
      BMdec = 0;
    }
    var amntDec=0; var amntMinDec=0
    if((item.TF).toString().split(".")[1]){
      amntDec = (item.TF).toString().split(".")[1].length
      for (let i = 0; i < amntDec; i++) {
        if((item.TF).toString().split(".")[1][i] === '0'){ amntMinDec +=1 ; }
      }
    }
   var pDec=0; var pMinDec=0;
    if((item.P).toString().split(".")[1]){
      pDec = (item.P).toString().split(".")[1].length
      for (let i = 0; i < pDec; i++) {
        if((item.P).toString().split(".")[1][i] === '0'){ pMinDec +=1 ; }
      }
    }
    var mf = JSON.parse(item.PTN).mf;
    var rf = JSON.parse(item.PTN).rf;
    item.ask =item.MA.toFixed(dec);
    item.bid=item.MB.toFixed(dec);
    item.cmdty=item.ID;
    item.dec=dec;
    item.BMdec= BMdec;
    item.amntDec=amntDec;
    item.pDec=pDec;
    item.amntMinDec=amntMinDec;
    item.pMinDec=pMinDec;
    item.minDec=minDec;
    item.BMminDec=BMminDec;
    var diff=Math.abs(Math.round(((item.MB.toFixed(dec)-item.MA.toFixed(dec)))*mf)).toFixed(rf);
    item.diff=diff;
    item.SQ=0;
    return {
      ...item,
      ask:   item.MA.toFixed(dec),
      bid:   item.MB.toFixed(dec),
      cmdty: item.ID,
      dec:  dec,
      BMdec:  BMdec,
      diff: diff,
      SQ:0
    };
  });
};

const getInitialNeoSocketData = (NeoComodity) => {
  return NeoComodity.map((item,index) =>{
      return{
        ...item,
        type:item.stk_type
      };
  });
}
const getInitialTradeData = (trdDataList) => {
  return trdDataList.map((item,index) => {
    return {
      ...item
    };
  });
};
const getUpdatedNeoSocketData =(socketNeoData, message) =>{
  const item =Object.assign([],socketNeoData);
  const msg=JSON.parse(message.data);
  for (let index = 0; index < item.length; index++) {
    if(msg.stkType===item[index].stk_type)
    {
      item[index].ask_price=msg.SA;
      item[index].bid_price=msg.SB;
      break;
    }
  }
  return item;
}
const getCmdtyArry = (message) => {
  const msg = JSON.parse(message.data).data;
  var temparray = [];
  for(var index=0;index<msg.length;index++)
  {
    const msgIndx=JSON.parse(msg[index]);
    temparray.push(msgIndx.I);
  }
  return temparray;
}
const getUpdatedSocketData = (socketData, message) => {
	  const msg = JSON.parse(message.data).data;
    const RT = JSON.parse(message.data).RT;
    let cmdtyArr=JSON.parse(localStorage.getItem('cmdtyArray'));
    for(var index=0;index<msg.length;index++)
    {
          const msgIndx=JSON.parse(msg[index]);
          const cmdty = msgIndx.I;

          const item=socketData.get(cmdty);
          if(item === undefined){
              continue;
          }

          item.askTiers=msgIndx.askTiers;
          item.bidTiers=msgIndx.bidTiers;
          item.Tr_A=[];
          item.Tr_B=[];
          item.SQ=msgIndx.SQ;
            if(msgIndx.T_A)
            {
              item.Tr_A=msgIndx.T_A;
            }
            if(msgIndx.T_B)
            {
              item.Tr_B=msgIndx.T_B;
            }
  	        let change = null;
            if (socketData.get(cmdty).bid && socketData.get(cmdty).bid < msgIndx.MB) {
  	          change = 'increment';
  	        } else if (socketData.get(cmdty).bid && socketData.get(cmdty).bid > msgIndx.MB) {
  	          change = 'decrement';
  	        }
  	        if (change !== null) {
  	          socketData.get(cmdty).variationInBid = change;
  	        }
  	        item.bid = msgIndx.MB.toFixed(item.dec);
            change = null;
           if (socketData.get(cmdty).ask && socketData.get(cmdty).ask < msgIndx.MA) {
             change = 'increment';
           } else if (socketData.get(cmdty).ask && socketData.get(cmdty).ask > msgIndx.MA) {
             change = 'decrement';
           }
           if (change !== null) {
             socketData.get(cmdty).variationInAsk = change;
           }
           item.ask = msgIndx.MA.toFixed(item.dec);
           try{
               item.H = msgIndx.H.toFixed(item.dec);
               item.L = msgIndx.L.toFixed(item.dec);
            
           }catch(e){

           }
            item.D = msgIndx.D;
            item.dec = item.dec;
            item.BMdec = item.BMdec;
            item.ch=item.ask-item.bid;
            item.RT =msgIndx.RT;
            //FD28108 updated MA , MB value to calculate the change in valuation and price in account balance
            item.MA=msgIndx.MA;
            item.MB=msgIndx.MB;
            socketData.set(msgIndx.I,item);
                   
            // if(cmdtyArr.length > 0){
            //   if(cmdtyArr.indexOf(msgIndx.I) !== -1){
            //     localStorage.setItem(msgIndx.I,JSON.stringify(item));
            //   }
            // }

        }
    return socketData;
	};
const updateAccbalBean = (msg,accBal,instList,neoList) =>{
    let askRate;
    let bidRate;
    try{
    if(msg.I!=="" && msg.I!==null){
      if(msg.T==="M")
      {      //online commodity
        const item = instList.get(msg.I);
          if(item===undefined){
                askRate=msg.MA;
                bidRate=msg.MB;
          }
          else {
              bidRate=item.MB;
              askRate=item.MA;
          }

        if(accBal.detonlBeanMap.get((msg.I))){
              switch (msg.U) {
                case "D":accBal.detonlBeanMap.get((msg.I)).Q=parseFloat(msg.V);break;
                case "T":accBal.detonlBeanMap.get((msg.I)).TQ=parseFloat(msg.V);break;
                case "SOQ":accBal.detonlBeanMap.get((msg.I)).OQ=parseFloat(msg.V);break;
                case "POQ":accBal.detonlBeanMap.get((msg.I)).OQ=parseFloat(msg.V);break;
                case "U":accBal.detonlBeanMap.get((msg.I)).UQ=parseFloat(msg.V);break;
            }
            accBal.detonlBeanMap.get((msg.I)).MA=calculateValue(accBal.detonlBeanMap.get((msg.I)),accBal.detonlBeanMap.get(msg.I).MP,askRate,bidRate,accBal.FD,"Q");
            accBal.detonlBeanMap.get((msg.I)).R=calculateValue(accBal.detonlBeanMap.get((msg.I)),accBal.detonlBeanMap.get(msg.I).MP,askRate,bidRate,accBal.FD,"R");
            accBal.detonlBeanMap.get((msg.I)).V=calculateValue(accBal.detonlBeanMap.get((msg.I)),100,askRate,bidRate,accBal.FD,"Q");
            accBal.detonlBeanMap.get((msg.I)).TV=calculateValue(accBal.detonlBeanMap.get((msg.I)),100,askRate,bidRate,accBal.FD,"TQ");
            accBal.detonlBeanMap.get((msg.I)).UV=calculateValue(accBal.detonlBeanMap.get((msg.I)),100,askRate,bidRate,accBal.FD,"UQ");
            accBal.detonlBeanMap.get((msg.I)).OV=calculateValue(accBal.detonlBeanMap.get((msg.I)),100,askRate,bidRate,accBal.FD,"OQ");
        }
        else {//new comodityBean
            var obj={};
            obj.C=msg.C;
            obj.D=msg.S;
            obj.INSTID=msg.I
            obj.DORM=msg.DORM;
            obj.MP=msg.MP;
            obj.Q=0;
            obj.TQ=0;
            obj.OQ=0;
            obj.UQ=0;
            switch (msg.U) {
              case "D":obj.Q=parseFloat(msg.V);obj.TQ=0;obj.OQ=0;obj.UQ=0;break;
              case "T":obj.TQ=parseFloat(msg.V);obj.Q=0;obj.OQ=0;obj.UQ=0;break;
              case "SOQ":obj.OQ=parseFloat(msg.V);obj.TQ=0;obj.Q=0;obj.UQ=0;break;
              case "POQ":obj.OQ=parseFloat(msg.V);obj.TQ=0;obj.Q=0;obj.UQ=0;break;
              case "U":obj.UQ=parseFloat(msg.V);obj.TQ=0;obj.OQ=0;obj.Q=0;break;
          }
          accBal.detonlBeanMap.set(msg.I,obj);
          accBal.detonlBeanMap.get((msg.I)).MA=calculateValue(accBal.detonlBeanMap.get((msg.I)),accBal.detonlBeanMap.get(msg.I).MP,askRate,bidRate,accBal.FD,"Q");
          accBal.detonlBeanMap.get((msg.I)).R=calculateValue(accBal.detonlBeanMap.get((msg.I)),accBal.detonlBeanMap.get(msg.I).MP,askRate,bidRate,accBal.FD,"R");
          accBal.detonlBeanMap.get((msg.I)).V=calculateValue(accBal.detonlBeanMap.get((msg.I)),100,askRate,bidRate,accBal.FD,"Q");
          accBal.detonlBeanMap.get((msg.I)).TV=calculateValue(accBal.detonlBeanMap.get((msg.I)),100,askRate,bidRate,accBal.FD,"TQ");
          accBal.detonlBeanMap.get((msg.I)).UV=calculateValue(accBal.detonlBeanMap.get((msg.I)),100,askRate,bidRate,accBal.FD,"UQ");
          accBal.detonlBeanMap.get((msg.I)).OV=calculateValue(accBal.detonlBeanMap.get((msg.I)),100,askRate,bidRate,accBal.FD,"OQ");
        }
      }
       else {
       }
    }
    else {        //neo commodity tempneodetBeanMap.get(item.stk_type),100,item.ask_price,item.bid_price accBal.detFundsBeanMap.get()value.Q;
      if(msg.T==="M"){
          const item = Object.assign([], neoList);
          let index1;
          let index
          let askRate;
          let bidRate;
            for ( index= 0; index < length; index++) {
                if (item[index].stk_type === msg.S) {
                  index1 = index;
                  break;
            }
          }
            if(index===item.length-1){
                  askRate=msg.MA;
                  bidRate=msg.MB;
            }
            else {
                askRate=item[index1].ask_price;
                bidRate=item[index1].bid_price;
            }
            if(accBal.detneoBeanMap.get(msg.S)){
                  switch (msg.U) {
                    case "D":accBal.detneoBeanMap.get(msg.S).Q=parseFloat(msg.V);
                    case "T":accBal.detneoBeanMap.get(msg.S).TQ=parseFloat(msg.V);
                    case "SOQ":accBal.detneoBeanMap.get(msg.S).OQ=parseFloat(msg.V);
                    case "POQ":accBal.detneoBeanMap.get(msg.S).OQ=parseFloat(msg.V);
                    case "U":accBal.detneoBeanMap.get(msg.S).UQ=parseFloat(msg.V);
                }
                accBal.detneoBeanMap.get(msg.S).MA=calculateValue(accBal.detneoBeanMap.get(msg.S),accBal.detneoBeanMap.get(msg.S).MP,askRate,bidRate,accBal.FD,"Q");
                accBal.detneoBeanMap.get(msg.S).R=calculateValue(accBal.detneoBeanMap.get(msg.S),accBal.detneoBeanMap.get(msg.S).MP,askRate,bidRate,accBal.FD,"R");
                accBal.detneoBeanMap.get(msg.S).V=calculateValue(accBal.detneoBeanMap.get(msg.S),100,askRate,bidRate,accBal.FD,"Q");
                accBal.detneoBeanMap.get(msg.S).TV=calculateValue(accBal.detneoBeanMap.get(msg.S),100,askRate,bidRate,accBal.FD,"TQ");
                accBal.detneoBeanMap.get(msg.S).UV=calculateValue(accBal.detneoBeanMap.get(msg.S),100,askRate,bidRate,accBal.FD,"UQ");
                accBal.detneoBeanMap.get(msg.S).OV=calculateValue(accBal.detneoBeanMap.get(msg.S),100,askRate,bidRate,accBal.FD,"OQ");
          }
          else{
                var obj={};
                obj.C=msg.C;
                obj.D=msg.S;
                obj.INSTID=(msg.I);
                obj.DORM=msg.DORM;
                obj.MP=parseFloat(msg.MP);
                switch (msg.U) {
                  case "D":obj.Q=parseFloat(msg.V);obj.TQ=0;obj.OQ=0;obj.UQ=0;break;
                  case "T":obj.TQ=parseFloat(msg.V);obj.Q=0;obj.OQ=0;obj.UQ=0;break;
                  case "SOQ":obj.OQ=parseFloat(msg.V);obj.TQ=0;obj.Q=0;obj.UQ=0;break;
                  case "POQ":obj.OQ=parseFloat(msg.V);obj.TQ=0;obj.Q=0;obj.UQ=0;break;
                  case "U":obj.UQ=parseFloat(msg.V);obj.TQ=0;obj.OQ=0;obj.Q=0;break;
              }
              accBal.detneoBeanMap.set(msg.S,obj);
              accBal.detneoBeanMap.get(msg.S).MA=calculateValue(accBal.detneoBeanMap.get(msg.S),accBal.detneoBeanMap.get(msg.S).MP,askRate,bidRate,accBal.FD,"Q");
              accBal.detneoBeanMap.get(msg.S).R=calculateValue(accBal.detneoBeanMap.get(msg.S),accBal.detneoBeanMap.get(msg.S).MP,askRate,bidRate,accBal.FD,"R");
              accBal.detneoBeanMap.get(msg.S).V=calculateValue(accBal.detneoBeanMap.get(msg.S),100,askRate,bidRate,accBal.FD,"Q");
              accBal.detneoBeanMap.get(msg.S).TV=calculateValue(accBal.detneoBeanMap.get(msg.S),100,askRate,bidRate,accBal.FD,"TQ");
              accBal.detneoBeanMap.get(msg.S).UV=calculateValue(accBal.detneoBeanMap.get(msg.S),100,askRate,bidRate,accBal.FD,"UQ");
              accBal.detneoBeanMap.get(msg.S).OV=calculateValue(accBal.detneoBeanMap.get(msg.S),100,askRate,bidRate,accBal.FD,"OQ");

          }
      }
        else {
          if(msg.U==="D"){
          if(accBal.detFundsBeanMap.get(msg.C))
          {
            accBal.detFundsBeanMap.get(msg.C).Q=parseFloat(msg.V);
            accBal.detFundsBeanMap.get(msg.C).FA=parseFloat(msg.Q);
          }
          else {
              var obj={};
              obj.C=msg.C;
              obj.D=msg.S;
              obj.FA=parseFloat(msg.Q);
              obj.Q=parseFloat(msg.V);
              obj.VWO=0;
              obj.UQ=0;
              obj.TQ=0;
              accBal.detFundsBeanMap.set(msg.C,obj);
          }
        }
        }
      }}catch(e){console.log(e);}
  return{
    defacccode:accBal.defacccode,
    mrgPerc:accBal.mrgPerc,
    lossLimit:accBal.lossLimit,
    nopLimit:accBal.nopLimit,
    dealValLimit:accBal.dealValLimit,
    haltMrgPerc:accBal.haltMrgPerc,
    FD:accBal.FD,
    marginFreeNOP:accBal.marginFreeNOP,
    detFundsBeanMap:accBal.detFundsBeanMap,
    detonlBeanMap:accBal.detonlBeanMap,
    detneoBeanMap:accBal.detneoBeanMap,
    TQFlag:accBal.TQFlag,
    UQFlag:accBal.UQFlag,
    OQFlag:accBal.OQFlag,
  }
}
const updateInst = (socketData, message) => {
	  const item = socketData.get(message.IID);
    if (!item) {
      return socketData;
    }
    item.OV=message.MIP;
    item.MXOV=message.MAPV;
    socketData.set(message.IID,item);
    return socketData;
  }

  const updateValDate =(socketData, message) => {
      for (var [key, item] of socketData) {
        var cmdty=item.I;
        var key;
        for(key in message)
        {
          if(key===cmdty){
            item.VD=message[key];
          }
        }
      };
      return socketData;
    }
  const updateAccbalBeanMrgPerc =(msg,accBal,instList,neoList) =>{
    //[{"STK":"EUR","P":6.0,"IID":1},{"STK":"GLD","P":8.0,"IID":12},"PLD":4.0,"SLV":5.0}]
    const defAC=JSON.parse(localStorage.getItem('DefaultAC')).AC;
    const instItem = Object.assign([], instList);
    const neoItem = Object.assign([], neoList);

    try{
    if(msg.AC===defAC){
      msg.CM.map((item,index)=>{
        if((item.IID)!=="" && (item.IID)!==null){
          let askRate;
          let bidRate;
          let index1;
            for ( let index= 0; index < instItem.length; index++) {
                if ((instItem[index].I) === (item.IID)) {
                  index1 = index;
                  break;
            }
          }
          askRate=instItem[index1].MA;
          bidRate=instItem[index1].MB;
          if(accBal.detonlBeanMap.get((item.IID))){
              accBal.detonlBeanMap.get((item.IID)).MP=item.P;
              accBal.detonlBeanMap.get((item.IID)).MA=calculateValue(accBal.detonlBeanMap.get((item.IID)),accBal.detonlBeanMap.get((item.IID)).MP,askRate,bidRate,accBal.FD,"Q");
              accBal.detonlBeanMap.get((item.IID)).V=calculateValue(accBal.detonlBeanMap.get((item.IID)),100,askRate,bidRate,accBal.FD,"Q");
            }
        }
        else{
          let askRate;
          let bidRate;
          let index1;
            for ( let index= 0; index < length; index++) {
                if ((neoItem[index].stk_type) === (item.IID)) {
                  index1 = index;
                  break;
            }
          }
          askRate=neoItem[index1].ask_price;
          bidRate=neoItem[index1].bid_price;
          if(accBal.detneoBeanMap.get(item.STK)){
              accBal.detneoBeanMap.get(item.STK).MP=item.P;
              accBal.detneoBeanMap.get(item.STK).MA=calculateValue(accBal.detneoBeanMap.get(item.STK),accBal.detneoBeanMap.get(item.STK).MP,askRate,bidRate,accBal.FD,"Q");
              accBal.detneoBeanMap.get(item.STK).V=calculateValue(accBal.detneoBeanMap.get(item.STK),100,askRate,bidRate,accBal.FD,"Q");
            }
        }
      });
      let mfnop;
      if(parseInt(msg.MFNOP)===1){
        mfnop=true;
      }
      else {
        mfnop=false;
      }
      return{
          defacccode:accBal.defacccode,
          mrgPerc:parseFloat(msg.MP),
          lossLimit:parseFloat(msg.LL),
          nopLimit:parseFloat(msg.NOPL),
          dealValLimit:parseFloat(msg.DL),
          haltMrgPerc:parseFloat(msg.HM),
          FD:accBal.FD,
          marginFreeNOP:mfnop,
          detFundsBeanMap:accBal.detFundsBeanMap,
          detonlBeanMap:accBal.detonlBeanMap,
          detneoBeanMap:accBal.detneoBeanMap,
          TQFlag:accBal.TQFlag,
          UQFlag:accBal.UQFlag,
          OQFlag:accBal.OQFlag,
    }
    }
    else {
      return accBal;
    }
  }catch(e){console.log(e);}
  }

  const refreshProxi = (socketData) => {
    let outstandingLm = JSON.parse(localStorage.getItem('outstandingLm'));
    var templmtArray = [];
    if (outstandingLm){
      if (outstandingLm.outstandingLmArr !== undefined) {
        if (outstandingLm.outstandingLmArr.length !== 0) {
          templmtArray = outstandingLm.outstandingLmArr;
        }
      }
    }
    for(let index1=0;index1<templmtArray.length;index1++) {
      let rate=0;
      let proximity=0;
      if(templmtArray[index1].cmdtyId !== undefined){
        let socketDataMap = socketData.get(templmtArray[index1].cmdtyId);
        rate=(templmtArray[index1].DT === appConstants.TRADER_BUY ? socketDataMap.ask:socketDataMap.bid);
        switch(parseFloat(templmtArray[index1].OT)) {
          case appConstants.LMT_ORD_TYPE: 
            if(templmtArray[index1].DT=== appConstants.TRADER_BUY){
              rate=socketDataMap.ask;
              proximity=(parseFloat(((""+templmtArray[index1].price).replace(/,/g, ''))-parseFloat(rate))/(parseFloat(rate)))*100*-1;
            }else {
              rate=socketDataMap.bid
              proximity=(parseFloat(((""+templmtArray[index1].price).replace(/,/g, ''))-parseFloat(rate))/(parseFloat(rate)))*100;
            }
            break;
          case appConstants.STOP_ORD_TYPE:
            if(templmtArray[index1].DT===appConstants.TRADER_BUY){
              rate=socketDataMap.bid;
              proximity=(parseFloat(((""+templmtArray[index1].price).replace(/,/g, ''))-parseFloat(rate))/(parseFloat(rate)))*100;
            }else {
              rate=socketDataMap.ask;
              proximity=(parseFloat(((""+templmtArray[index1].price).replace(/,/g, ''))-parseFloat(rate))/(parseFloat(rate)))*100*-1;
            }
            break;
          case appConstants.OCO_ORD_TYPE:
          case appConstants.OTO_ORD_TYPE:
            if (templmtArray[index1].DOT === appConstants.STOP_ORD_TYPE){
              if(templmtArray[index1].DT===appConstants.TRADER_BUY){
                rate=socketDataMap.bid;
                proximity=(parseFloat(((""+templmtArray[index1].price).replace(/,/g, ''))-parseFloat(rate))/(parseFloat(rate)))*100;
              }else {
                rate=socketDataMap.ask;
                proximity=(parseFloat(((""+templmtArray[index1].price).replace(/,/g, ''))-parseFloat(rate))/(parseFloat(rate)))*100*-1;
              }
            }else {
              if(templmtArray[index1].DT=== appConstants.TRADER_BUY){
                rate=socketDataMap.ask;
                proximity=(parseFloat(((""+templmtArray[index1].price).replace(/,/g, ''))-parseFloat(rate))/(parseFloat(rate)))*100*-1;
              }else {
                rate=socketDataMap.bid
                proximity=(parseFloat(((""+templmtArray[index1].price).replace(/,/g, ''))-parseFloat(rate))/(parseFloat(rate)))*100;
              }
            }
            break;
        }
        templmtArray[index1].proximity = templmtArray[index1].proximity != null ? parseFloat(proximity).toFixed(2) : "";
      }
    }
    outstandingLm.outstandingLmArr = templmtArray;
    outstandingLm.randomNo = Math.floor((Math.random() * 1000000) + 1);
    let openedWidgets = localStorage.getItem('openedWidgets');
    let flag= 0;
    if (openedWidgets ) {
      JSON.parse(openedWidgets).map((widget) => {
        if (widget.substring(0, 16) === "OutstandingOrder") {
          flag=1;
        }
      })
    }
    if(flag === 1) {
      localStorage.setItem('limitOrdBook', JSON.stringify(limitOrdBook));
    }
    localStorage.setItem('outstandingLm',JSON.stringify(outstandingLm));
    return outstandingLm;
  }

  function addCustomTenor(tenorData = []) {
    const customObj = {
      date: "",
      tenor: "CUSTOM",
    };
  
    return tenorData.map((commodity) => {
      const details = Array.isArray(commodity.details)
        ? commodity.details
        : [];
  
      // Prevent duplicate CUSTOM entry
      const hasCustom = details.some(
        (item) => item.tenor === "CUSTOM"
      );
  
      return {
        ...commodity,
        details: hasCustom
          ? details
          : [customObj, ...details],
      };
    });
  }
  

  export default function(state = initialState, action)  {
  switch (action.type) {
    case types.SUCCESS_DEFAULT:
      return {
        ...state,
      };
    case types.FAILURE_DEFAULT:
      return {
        ...state,
      };
    case types.LOAD_INSTRUMENT_LIST:
      return {
        ...state,
      };
    case types.LOAD_INSTRUMENT_LIST_SUCCESS:
    //localStorage.setItem('socketData', JSON.stringify(getInitialSocketData(action.result.data.Inst)));
    localStorage.setItem('trdPanelData',JSON.stringify(getInitialTradeData(action.result.data.S)));
    localStorage.setItem('socketDataStatic',JSON.stringify(getInitialTradeData(action.result.data.Inst)));
      return {
        ...state,
        socketData: getInitialSocketData(action.result.data.Inst),
        socketDataStatic: getInitialStaticSocketData(action.result.data.Inst),
        trdPanelData: getInitialTradeData(action.result.data.S),
        unitData: getInitialTradeData(action.result.data.U),
        currencyData:getInitialTradeData(action.result.data.C),
        socketNeoData:getInitialNeoSocketData(action.result.data.NeoCom),
        localCurrency:getInitialTradeData(action.result.data.BC),
      };

     case types.LOAD_INSTRUMENT_LIST_FAILURE:
    	//localStorage.setItem('user', null);
      return {
        ...state,
      };
    case types.UPDATE_STATUS:
        localStorage.setItem('status', 1);
      	return {
          ...state,
          status: "1"
        };
    case types.UPDATE_SOCKET_DATA:
    const message=action.message;
    const msgData=JSON.parse(message.data);
    const BCM=msgData.BCM;
    if(BCM!==undefined){
            if(BCM===appConstants.CONN_STATUS_CHANGE){
              localStorage.setItem('status', JSON.parse(message.data).S);
              return{
                ...state,
                status:JSON.parse(message.data).S
              };
            }else if(BCM==="901"){
              return {
                     ...state,
                     socketData: getUpdatedSocketData(state.socketData, action.message),
                     check:""+Math.random(),
                     cmdtyArr: getCmdtyArry(action.message),
                    accBalBean:updateMargin(state.accBalBean,action.message),
                    marginData:calculateMargin(state.accBalBean),
                   };
            }
        }
      else{
        return {
          ...state,
          socketNeoData: getUpdatedNeoSocketData(state.socketNeoData, action.message),
          accBalBean:updateNeoMargin(state.accBalBean,action.message),
          marginData:calculateMargin(state.accBalBean),
        };
      }
    // }
    //need to check when this come
    // case types.UPDATEMARGIN:
    // return{
    //   ...state,
    // //  accBalBean:updateMargin(state.accBalBean,state)
    // };
    case types.LOAD_SOCKET_DATA:
      return {
        ...state,
      };
    case types.CLOSE_SOCKET_DATA:
      return {
        ...state,
        webSocketFlag:false,
      };
      case types.SUBSCRIBE_TIER:
      return {
        ...state,
      }
      case types.UNSUBSCRIBE_TIER:
      return {
        ...state,
      }
      case types.LOAD_ACCBAL:
        return {
          ...state,
            accBalBean:intializeMargindata(action.accBal,state.socketData,state.socketNeoData),
            marginData:calculateMargin(state.accBalBean),
        };
      case types.LOAD_MARGINCOMPONENT:
        return {
          ...state,
        marginData:calculateMargin(state.accBalBean),
        };
        case types.UPDATE_ACCBAL:
        return {
          ...state,
          accBalBean:updateAccbalBean(action.msg,state.accBalBean,state.socketData,state.socketNeoData),
          marginData:calculateMargin(state.accBalBean),
        }
        case types.UPDATE_INST:
        return{
          ...state,
          socketData:updateInst(state.socketData,action.msg)
        }
        case types.UPDATE_MARGIN_PERC:
        return{
          ...state,
          accBalBean:updateAccbalBeanMrgPerc(action.msg,state.accBalBean,state.socketData,state.socketNeoData),
          marginData:calculateMargin(state.accBalBean),
        }
        case types.LOAD_ACCOUNT:
        	 return{
        	 	...state,
        }
        case types.LOAD_ACCOUNT_SUCCESS:
        	 return{
        	 	...state,
                accBalBean:intializeMargindata(action.result.data,state.socketData,state.socketNeoData),
                marginData:calculateMargin(state.accBalBean),
        }
        case types.LOAD_ACCOUNT_FAILURE:
        	 return{
        	 	...state,
         }
        case types.SOCKET_FLAG:
        var flag=action.flag;
        return{
          ...state,
          webSocketFlag:flag,
        }
        case types.UPDATE_VALUEDATE:
          const updatedData = updateValDate(state.socketData,action.message);
          const dataInArray = Array.from(updatedData.values());
          getInitialSocketData(dataInArray);
          // Updating localStorage with new data
          localStorage.setItem('socketDataStatic', JSON.stringify(dataInArray));
          let randomNo=Math.floor((Math.random() * 10) + 1)
          localStorage.setItem('randomNoVD', JSON.stringify(randomNo));
          return{
            ...state,
            socketData: updatedData,
            socketDataStatic: dataInArray,
            check:""+Math.random(),
            randomNoVD:randomNo
          }
        case types.RESET_STATE_SOCKET:
      		return{
      			...state,
            socketData: [],
            socketDataStatic: [],
            socketNeoData:[],
            trdPanelData:[]
      		}
      case types.REFRESH_PROXIMITY:
        var proxiRandomNo=Math.floor((Math.random() * 100) + 1);
        return{
            ...state,
            limitOrdBookProxi:refreshProxi(state.socketData),
            proxiRandomNo:proxiRandomNo,
        }
        
    case types.SUBSCRIBE_FWD_RATES:
        return {
            ...state,
        }
      
    case types.UPDATE_FORWARDS_DATA :
        if (!fwdSubscriptionMap.has(action.payload.streamName)) {
            action.payload.updateFWDStates();
        }
        fwdSubscriptionMap.set(action.payload.streamName, action.payload.fwdData);
        const fwdMsg = JSON.parse(action.payload.fwdData)
        const updatedFwdData = {
          ...state.LSData,
          fwdData: fwdMsg.LS_ID ? fwdMsg: null
        };        
        return {
            ...state,
            fwdSubscription: fwdSubscriptionMap,
            LSData : updatedFwdData,
        };
    
    case types.UNSUBSCRIBE_FWD_RATES : 
        const subscriptionMap = new Map(state.fwdSubscription);
        subscriptionMap.delete(action.payload.subscribedPair)
        return {
            ...state,
            fwdSubscription: subscriptionMap
        };

    case types.GET_VAL_DATE:
      localStorage.setItem("tenorStatus","Loading");
      localStorage.setItem("tenorData",JSON.stringify([]))
        return {
        ...state,
        tenorStatus: "Loading",
      };  
    
      case types.GET_VAL_DATE_SUCCESS: {
        const incomingData = action.result.data; 
      
        // Read allowed commodities from localStorage
        const trdPnlCmdty =
          JSON.parse(localStorage.getItem("trdPnlCmdty"))?.array || [];
      
        // Remove empty values just in case
        const allowedIIDs = trdPnlCmdty.filter(Boolean);
      
        // Start with existing data filtered by allowed IIDs
        let existingData = state.tenorData.filter(item =>
          allowedIIDs.includes(item.IID)
        );
      
        incomingData.forEach((newItem) => {
      
          const index = existingData.findIndex(
            (item) => item.IID === newItem.IID
          );
      
          if (index === -1) {
            if (allowedIIDs.includes(newItem.IID) || !state.tenorData.some(item => item.IID === newItem.IID)) {
              existingData.push(newItem);
            } 
          } else {
            existingData[index] = {
              ...existingData[index],
              details: newItem.details,
            };
          }
        });
      
        const updatedTenorData = addCustomTenor(existingData);
      
        localStorage.setItem("tenorData", JSON.stringify(updatedTenorData));
        localStorage.setItem("tenorStatus", "Loaded");
      
        const panel = JSON.parse(action.response)?.panel;
      
        return {
          ...state,
          tenorData: updatedTenorData,
          tenorStatus: "Loaded",
          panel,
        };
      }
      
    case types.GET_VAL_DATE_FAILURE:
      localStorage.setItem("tenorStatus","Failed");
      localStorage.setItem("tenorData",JSON.stringify([]));
        return {
        ...state,
        tenorStatus: "Failed",
      };

    case types.GET_SWAP_LOCATIONS:  
    localStorage.setItem("swapLocations",JSON.stringify([]))
      return {
        ...state,
        swapLocations: [],
      };   

    case types.GET_SWAP_LOCATIONS_SUCCESS: 
       localStorage.setItem("swapLocations",JSON.stringify(action.result.data))
        return {
          ...state,
          swapLocations: action.result.data,
        };    

    case types.GET_SWAP_LOCATIONS_FAILURE:
      localStorage.setItem("swapLocations",JSON.stringify([]))
      return {
        ...state,
        swapLocations: [],
      };

    case types.RESET_TENOR_DATA:
      localStorage.setItem("tenorData",JSON.stringify([]));
      localStorage.setItem("tenorStatus","");
      return {
        ...state,
        tenorData:[],
        tenorStatus: null,
      };
      
    default:
      return state;
  }
}